import Vue from "vue";
import VueI18n from "vue-i18n";
import en_US from "@/locales/en_US.json";
import zh_CH from "@/locales/zh_CH.json";
import zh_TW from "@/locales/zh_TW.json";

Vue.use(VueI18n);

const defaultLocales = {
    locales: ["en_US", "zh_CH", "zh_TW"],
    locale: "en_US",
};

const messages = {
    en_US: en_US,
    zh_CH: zh_CH,
    zh_TW: zh_TW,
};

const i18n = new VueI18n({
    locale: defaultLocales.locale,
    fallbackLocale: "zh_TW", //表示當未設定對應的語系字典時，以 zh_TW 為預設顯示
    messages: messages,
});

Object.defineProperty(i18n, "changeLocale", {
    get () {
        return i18n.locale;
    },
    set (locale) {
        if (defaultLocales.locales.includes(locale)) {
            i18n.locale = locale;
        }
    }
});

export default i18n;
